// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DataTablePresentationPropsDefault from "@insite/mobius/DataTable/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import { DataTableCssOverrides } from "@rc/MobiusOverrides/DataTable/DataTable";
import { xBaseTheme } from "@rc/XDL/types";
import { color, xScreen } from "@rc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DataTablePresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            wrapper: css`
                tbody {
                    border: 1px solid ${color("common.border")};
                }
                tbody tr:last-child td {
                    border-bottom: 0;
                }
            `,
            cell: css`
                & {
                    height: auto;
                    padding: 8px 12px 10px 12px;
                    border-bottom: 1px solid ${color("common.ui3")};
                    color: ${color("text.main")};
                    font-size: 16px;
                    span,
                    a,
                    a span {
                        font-size: 16px;
                        padding: 0;
                        color: ${color("text.main")} !important;
                        font-weight: 300;
                    }
                    button:hover,
                    a:hover {
                        color: ${color("primary")};
                        span {
                            color: ${color("primary")} !important;
                        }
                    }
                }
            `,
            head: css`
                border: 1px solid ${color("common.border")};
            `,
            header: css`
                position: relative;
                text-align: left;
                padding: 8px 12px;
                background: ${color("common.ui2")};
                border-bottom: 1px solid ${color("common.ui3")};
                font-weight: 400;
                color: ${color("common.ui10")};
                height: auto;
                button {
                    margin-right: 60px;
                }
                ${TypographyStyle} {
                    font-size: 14px;
                    font-weight: 600;
                }

                &:last-child {
                    z-index: 2;
                }
            `,
            row: css`
                background: ${color("common.ui1")};
            `,
            evenRow: css`
                background: ${color("common.ui1")};
            `,
        } as DataTableCssOverrides,
        headerTypographyProps: {
            mergeCss: true,
            size: 18,
            weight: 600,
            color: "text.main",
            css: css`
                ${xScreen("lte", "md")} {
                    font-size: 16px;
                }
            `,
        },
        cellTypographyProps: {
            mergeCss: true,
            size: 16,
            css: css`
                letter-spacing: 0;
                line-height: 24px;
                font-weight: 300;

                & {
                    font-size: 16px;
                }
            `,
        },
        sortClickableProps: {
            css: css`
                width: 100%;

                &:focus {
                    outline: none;
                }
            `,
        },
        sortIconProps: {
            size: 7,
            css: css`
                margin-left: 8px;
                position: absolute;
                right: 12px;
            `,
        },
        sortIconSources: {
            sortable: "CaretDown",
            ascending: "CaretUp",
            descending: "CaretDown",
            none: "Minus",
            other: "Activity",
        },
    },
} as xBaseTheme["dataTable"];
